import React from "react";

export const ContactsTable = ({
  contacts,
  leadMagnetAvailable,
  onDelivery,
  onMarkSent,
}) => (
  <div className="mt-10 overflow-x-auto wk-card">
    <table className="w-full min-w-[960px] text-left" data-testid="contacts-table">
      <thead style={{ background: "#FAF9FB", color: "#70667A" }}>
        <tr className="text-[11px] uppercase tracking-[0.12em]">
          <th className="p-4">Fecha</th>
          <th className="p-4">Nombre y apellidos</th>
          <th className="p-4">Email</th>
          <th className="p-4">WhatsApp</th>
          <th className="p-4">Canal</th>
          <th className="p-4">Ofertas</th>
          <th className="p-4">Enviado</th>
          <th className="p-4">Acciones</th>
        </tr>
      </thead>
      <tbody>
        {contacts.map((contact) => (
          <tr
            key={contact.id}
            className="border-t text-[13px]"
            style={{ borderColor: "#DEDAE2", color: "#1E1924" }}
            data-testid={`contact-row-${contact.id}`}
          >
            <td className="p-4">{new Date(contact.creado).toLocaleDateString("es-ES")}</td>
            <td className="p-4 font-medium">{contact.nombre} {contact.apellidos}</td>
            <td className="p-4">{contact.email}</td>
            <td className="p-4">{contact.prefijo || ""}{contact.whatsapp || "—"}</td>
            <td className="p-4">{contact.canal}</td>
            <td className="p-4">{contact.consentimiento_ofertas ? "sí" : "no"}</td>
            <td className="p-4">{contact.enviado ? "sí" : "no"}</td>
            <td className="p-4">
              <div className="flex gap-2">
                <button
                  className="text-left underline disabled:no-underline disabled:opacity-50"
                  disabled={!leadMagnetAvailable || !contact.whatsapp || !contact.prefijo}
                  onClick={() => onDelivery(contact.id, "whatsapp")}
                  data-testid={`contact-whatsapp-${contact.id}`}
                >
                  {leadMagnetAvailable ? "Enviar por WhatsApp" : "Disponible muy pronto"}
                </button>
                <button
                  className="text-left underline disabled:no-underline disabled:opacity-50"
                  disabled={!leadMagnetAvailable}
                  onClick={() => onDelivery(contact.id, "email")}
                  data-testid={`contact-email-${contact.id}`}
                >
                  {leadMagnetAvailable ? "Enviar por email" : "Disponible muy pronto"}
                </button>
                <button
                  className="text-left underline"
                  onClick={() => onMarkSent(contact.id)}
                  data-testid={`contact-mark-sent-${contact.id}`}
                >
                  Marcar como enviado
                </button>
              </div>
            </td>
          </tr>
        ))}
        {contacts.length === 0 ? (
          <tr data-testid="contacts-empty-state">
            <td className="p-6" colSpan="8">Todavía no hay contactos.</td>
          </tr>
        ) : null}
      </tbody>
    </table>
  </div>
);